/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Kevin Wang",
  title: "Welcome! I am Kevin Wang",
  subTitle: emoji(
    "A master student with a passion for technology and a strong academic background."
    //"A passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Eren-Jeager123",
  linkedin: "https://www.linkedin.com/in/kevin-wang-595175289/",
  gmail: "kwang442@usc.edu",
  instagram: "https://www.instagram.com/kwang11_11/",
  scholar: "https://scholar.google.com/citations?user=LtA2hBUAAAAJ&hl=en",
  //gitlab: "https://gitlab.com/saadpasta",
  //facebook: "https://www.facebook.com/saad.pasta7",
  //medium: "https://medium.com/@saadpasta",
  //stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "LOOKING FOR A JOB !!",
  subTitle: "SKILLS",
  skills: [
    emoji(
      "⚡ Solid academic background, graduated from one of the top universities in China."
    ),
    emoji(
      "⚡ Strong experience in font-end/mobile development projects and internships."
    ),
    emoji(
      "⚡ Involved in the development of products with hundreds of millions of users"
    ),
    emoji("⚡ Extensive research and internship experience in ML.")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "C/C++",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Objective-C",
      fontAwesomeClassname: "fas fa-file-code"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Southern California",
      logo: require("./assets/images/usc.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "August 2023 - Expected May 2025",
      desc: "Ranked top 1% in the program. Took courses about Machine Learning, Analysis of Algorithm, Web Technologies, ...",
      descBullets: [
        "GPA 4.0/4.0",
        "Achieved a perfect score in the Database Systems exam (one of only 7 out of 680 students!).",
        "Participated in the research of ML and published 1 paper at AAAI."
      ]
    },
    {
      schoolName: "Peking University",
      logo: require("./assets/images/pku2.png"),
      subHeader: "Bachelor of Science in Computer Science and Technology",
      duration: "September 2019 - July 2023",
      desc: "Ranked top 25% in the program. Took courses about Data Structure and Algorithm, Operating System, Computer Networks, ...",
      descBullets: [
        "GPA 3.7/4.0",
        "STRONG Mathematical Foundation - 96 in Advanced Mathematics; 95 in Algebraic Structure and Combinational Mathematics; 93 in Mathematical Logic",
        "Received 5 scholarships, including Outstanding Graduate Award and others."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Mobile Development", //Insert stack or technology you have experience in
      progressPercentage: "95%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Machine Learning",
      progressPercentage: "95%"
    },
    {
      Stack: "Front End",
      progressPercentage: "85%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer - iOS Developer",
      company: "Tencent - WeChat Group",
      companylogo: require("./assets/images/tencent.webp"),
      date: "July 2024 – September 2024",
      desc: "The Largest IT Company in China",
      descBullets: [
        "Developed live-streaming features for WeChat Channles using Objective-C (a product with hundreds of millions of users!).",
        "Implemented a local stream merging algoirhm using OpenGL and Metal, reducing CPU usage by 7% while keeping GPU utilization at its lowest.",
        "Applied the implemented algorithm to the product."
      ]
    },
    {
      role: "Machine Learning Engineer",
      company: "KNQ Technology",
      companylogo: require("./assets/images/knq.png"),
      date: "January 2024 – Jun 2024",
      desc: (
        <>
          <a href="https://knqtech.com.cn/" target="_blank" rel="noreferrer">
            An AI Startup Company
          </a>
        </>
      ),
      descBullets: [
        "COOL Idea ---- developed an AI-powered esports/sports commentary project.",
        "Created the DOTA2 ASR dataset and fine-tuned the OpenAI Whisper model, achieving a 30% improvement in WER (Word Error Rate).",
        "Implemented several visual models to assist with RAG (Retrieval-Augmented Generation)."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "Papers & Web Design",
  projects: [
    {
      image: require("./assets/images/AAAI.png"),
      projectName: "AAAI !!",
      projectDesc: "LLM - Time Series Forecasting",
      footerLink: [
        {
          name: "Visit Paper",
          url: "https://ojs.aaai.org/index.php/AAAI/article/view/30383"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/pku2.png"),
      projectName: "Undergraduate Research !!",
      projectDesc: "Multimodal Continual Learning",
      footerLink: [
        {
          name: "Visit Paper",
          url: "https://drive.google.com/file/d/19vrEdsdW69Lzdb9BNWmjGDlmZzUx9Pgf/view?usp=drive_link"
        }
      ]
    },
    {
      image: require("./assets/images/MEAN.png"),
      projectName: "MEAN Stack Web Design !!",
      projectDesc: "A Stock Search & Deal Website",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://myhw3angular.wl.r.appspot.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "雀神",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "只狼八周目双难",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "双城之战铁粉",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Feel free to reach out if you're interested in collaborating on a project or discussing job opportunities. My inbox is always open!",
  number: "+1 (213) 610-8260",
  email_address: "kwang442@usc.edu"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
